module.exports = __webpack_public_path__ + "static/img/3s-platform-img9.e9f8dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img9.png
// module id = Jgfk
// module chunks = 0